module.exports = __webpack_public_path__ + "static/media/pdf-icon.8abce974.svg";